import * as React from "react";

import { ChevronsUpDown, Plus } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

export function Org({ compact = false }: { compact?: boolean }) {
  const { isMobile } = useSidebar();

  return (
    <div
      className={
        compact
          ? "flex flex-row gap-2 items-center"
          : "flex flex-row gap-2 items-center group-not-has-data-[collapsible=icon]/sidebar-wrapper:px-2 "
      }
    >
      <div className="flex aspect-square size-8 items-center justify-center rounded-lg">
        <img
          className="h-8 w-8 transition-all group-hover:scale-110 p-1 bg-black rounded-lg"
          src="/logo.svg"
        />
      </div>
      {!compact && (
        <div className="grid flex-1 text-left text-sm leading-tight group-has-data-[collapsible=icon]/sidebar-wrapper:hidden">
          <span className="truncate font-medium">Mood IMS</span>
        </div>
      )}
    </div>
  );
}
